import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { getMasterEntityTypeAsync, resetSelectedRecordObjectInState, getDataByMasterEntityTypeIdAsync, LinkClicked,updatePagination } from "./CustomFieldSlice";
import CustomFieldItem from "./CustomFieldItem";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { getPagePermissionsAsync } from "../../../common/GlobalSlice";
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList,sortData, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';
import CustomPagination from "../../../common/Pagination";
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';


const CustomField = () => {

  const dispatch = useAppDispatch();
  const { masterEntityTypeList, customFieldList,isReload,isLoading,sortOrder, sortColumn, search, pageNo, pageSize } = useAppSelector((state) => state.customField);
  const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, manageTerminologyList } = useAppSelector((state) => state.globalState);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();


  useLayoutEffect(() => {
    const fetchPagePermissions = async () => {
      if (pageId && pageId !== '') {
        const res = await dispatch(getPagePermissionsAsync(pageId));
        if (!res.payload.IsList) {
          navigate('../error/403');
        }
      } else if (!pageId && menuList && menuList.length > 0) {
        const routeName = location.pathname.split('/').filter(Boolean)[0];
        const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
        console.log('foundItem:', foundItem);
        if (foundItem) {
          const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
          if (!res.payload.IsList) {
            navigate('../error/403');
          }
        } else {
          navigate('../error/403');
        }
      }
    };
    fetchPagePermissions();
  }, [dispatch, location.pathname, menuList, navigate, pageId]);

  const handlePageChange = (pageNumber: any) => {
    // setCurrentPage(pageNumber);
    let objects = {
        "pageSize": pageSize,
        "pageNo": pageNumber,
        "search": search
    }
    dispatch(updatePagination(objects));
};

const handleSearch = (event: any) => {
    const { value } = event.target;
    // setSearchTerm(value);
    // setCurrentPage(1);
    let objects = {
        "pageSize": pageSize,
        "pageNo": 1,
        "search": value
    }
    dispatch(updatePagination(objects));
};

const handlePageSizeChange = (selectedOption: any) => {
    const { value, label } = selectedOption;
    // setPageSize(Number(value));
    // setCurrentPage(1);
    let objects = {
        "pageSize": value,
        "pageNo": 1,
        "search": search
    }
    dispatch(updatePagination(objects));
};

const filteredData: any = getFilteredList(masterEntityTypeList, search);
const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
const indexOfLastItem = pageNo * pageSize;
const indexOfFirstItem = indexOfLastItem - pageSize;
// const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
const totalItems = masterEntityTypeList.length;
const recordsFiltered = filteredData.length;

  useEffect(() => {

    if (isReload) {
      dispatch(getMasterEntityTypeAsync());
    }
  }, [isReload]);

  const handleOnClickEvent = () => {
    dispatch(resetSelectedRecordObjectInState());
    setIsModalOpen(true);
}
  const openModal = () => {
    setIsModalOpen(true);
};

const closeModal = () => {
    setIsModalOpen(false);
};
  useEffect(() => {
    dispatch(getMasterEntityTypeAsync());

  }, [dispatch]);

    

  return (
    <>
{isLoading && <Loader />}
      <div className="card card-custom admin-card">
        <div className="card-header card-drop sticky-top fixed-top bg-white">
          <h3 className="card-title fw-bold headerTitle d-flex align-items-center gap-1" >
            {/* {t('Custom Field List')} */}
            {getValueFromResource('Custom Field List', dispatch, t)}
            <div
              style={{ marginBottom: "2px" }}
              data-tooltip-id="tooltip-customField"
              data-tooltip-content={getValueFromResource("Create and manage custom fields for supported modules, allowing your organization to capture additional information without modifying the standard application structure.", dispatch, t)}
            >
              <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
            </div>

          </h3>
          <div className="card-toolbar">
          <div className="position-relative">
                                <input
                                    type="text"
                                    value={search}
                                    onChange={handleSearch}
                                    placeholder=
                                    // {t('Search')}
                                    {getValueFromResource('Search',dispatch, t)}
                                    className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                    data-kt-user-table-filter="search"

                                />
                                <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                            </div>
                            <div className='h-35px w-1px mx-1'></div>
                            <div className="d-flex align-items-center">
                                {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'

                                /> */}
                                <PageSizeSelect onChange={handlePageSizeChange} />
                            </div>


                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <div>
                                {(currentItems.length > 0) ? (
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                        recordsFiltered={recordsFiltered}
                                    >
                                    </CustomPagination>
                                ) : null}
                            </div>
                            {(IsAdd || (IsDelete && customFieldList.some((item: any) => item.isSelected === 1))) ? (
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            ) : null
                            }


          </div>
        </div>
        {IsList &&
          // <div className="card-body">
          <div className="card-Report-body">
            <div className="table-responsive">
              <CustomFieldItem masterEntityTypeList={currentItems} t={t} IsEdit={IsEdit} />

            </div>
          </div>
        }
      </div>
      <ReactTooltip
        id="tooltip-customField"
        style={TOOLTIP_STYLE}
        place="bottom"
        delayShow={100}
        delayHide={100}
        clickable
        render={({ content }) => {
          const isLongContent = content && content?.length > 90;
          return (
            <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
              {content}
            </div>
          );
        }}
      />
    </>
  )
}

export default CustomField;